import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DeviceList } from '../gateway.model';

export enum GateWayDeviceActionTypes {
  ReadGatewayDeviceList = '[GateWay] Read Gateway Device List',
  UpsertGatewayDeviceList = '[GateWay] Upsert Gateway Device List',
  ReadGatewayDeviceListFail = '[GateWay] Read Gateway Device List Fail',
  AddDeviceToCloud = '[GateWay] Add Device To Cloud',
  ResultAddDeviceToCloud = '[GateWay] Result Add Device To Cloud',
}

export class ReadGatewayDeviceList implements Action {
  readonly type = GateWayDeviceActionTypes.ReadGatewayDeviceList;

  constructor(public payload: any = null) {}
}
export class UpsertGatewayDeviceList implements Action {
  readonly type = GateWayDeviceActionTypes.UpsertGatewayDeviceList;

  constructor(public payload: any) {}
}
export class ReadGatewayDeviceListFail implements Action {
  readonly type = GateWayDeviceActionTypes.ReadGatewayDeviceListFail;

  constructor(public payload: any = null) {}
}
export class AddDeviceToCloud implements Action {
  readonly type = GateWayDeviceActionTypes.AddDeviceToCloud;

  constructor(public payload: any = null) {}
}
export class ResultAddDeviceToCloud implements Action {

  readonly type = GateWayDeviceActionTypes.ResultAddDeviceToCloud;

  constructor(public payload: any) { }
}



export type GateWayDeviceActions =
ReadGatewayDeviceList
 | UpsertGatewayDeviceList
 | ReadGatewayDeviceListFail
 | AddDeviceToCloud
 | ResultAddDeviceToCloud
